export default function CheckIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5858 6L10 14.5858L6.41426 11H5.00002V12.4142L9.29292 16.7071L10 17.4142L10.7071 16.7071L20 7.41424V6H18.5858Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
